<template>
  <div class="tw-relative custom-form" :class="{ 'tw-h-12': isDropdown }">
    <label
      @click="$emit('label-click')"
      :for="label"
      v-if="label"
      class="tw-text-black-light custom-form__label tw-font-medium"
      :class="[
        inputActive ? 'custom-form__label--active' : null,
        removeMarginLeft ? 'tw-ml-2' : 'tw-ml-5',
        isDropdown ? 'custom-form__label--z-index' : null,
      ]"
      >{{ label }}
      <span
        class="tw-text-red-error"
        v-if="required && $route.name !== 'SignIn'"
        >*</span
      ></label
    >
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "InputFieldLabel",
    data() {
      return {};
    },
    emits: ["label-click"],
    props: {
      label: {
        type: String,
      },
      inputActive: {
        type: Boolean,
        required: true,
        default: () => false,
      },
      removeMarginLeft: {
        type: Boolean,
        required: false,
        default: () => false,
      },
      isDropdown: {
        type: Boolean,
        required: false,
        default: () => false,
      },
      required: {
        type: Boolean,
        required: false,
        default: () => {
          return true;
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
  // Enterprise Professional Design System
  $text-primary: #0F172A;
  $text-secondary: #475569;
  $text-muted: #64748B;
  $text-placeholder: #94A3B8;
  $border-color: #CBD5E1;
  $border-focus: #001240;
  $background-white: #FFFFFF;
  $background-subtle: #F8FAFC;

  .custom-form {
    &__label {
      position: absolute;
      transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
      top: 14px;
      left: 0;
      color: $text-placeholder;
      padding: 0 12px;
      font-size: 14px;
      font-weight: 450;
      letter-spacing: -0.01em;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      pointer-events: none;
      
      &--z-index {
        z-index: 1;
      }
      
      &--active {
        font-size: 11px;
        font-weight: 500;
        top: -8px;
        left: 8px;
        z-index: 2;
        height: 16px;
        display: flex;
        align-items: center;
        background: linear-gradient(180deg, transparent 50%, $background-white 50%);
        padding: 0 6px;
        color: $text-secondary;
        letter-spacing: 0.02em;
        text-transform: uppercase;
      }
    }
  }
</style>
